<style scoped>
.el-form-item__content{
  display: flex;
}
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.tab-plane {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.tab-plane .tab-list {
  width: 50%;
  line-height: 32px;
  background: rgb(240, 239, 239);
  cursor: pointer;
  border: 1px solid #ddd;
  text-align: center;
  /* border-radius: 6px; */
}
.tab-active {
  background: #fff !important;
  border: 1px solid #4fa1a4 !important;
}
.tags-logo {
  width: 16px;
  margin-top: 2px;
  margin-right: 10px;
}
.tags-edit {
  width: 20px;
  margin-top: 2px;
  margin-right: 10px;
}
.tags-del {
  width: 16px;
  margin-top: 2px;
}
.tags-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}
.tags-list-left {
  width: calc(100% - 40px);
  display: flex;
  align-items: center;
}
.tags-list:hover {
  background: rgb(245, 244, 244);
}
.tags-active {
  color: #4fa1a4 !important;
  background: rgb(245, 244, 244);
}
.edit-tags-text {
  padding: 0 80px;
  display: flex;
}
.el-icon-check {
  color: #4fa1a4;
}
.add-edit-search {
  margin: 20px 0;
  padding-bottom: 35px;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
}
.ab-detail-person {
  float: right;
  margin-right: 28px;
  font-size: 14px;
  font-weight: 400;
}
.no-tag-data {
  color: #909399;
  margin-top: 35px;
  text-align: center;
}
.tags-list-left span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-tree-node {
  display: flex;
  align-items: center;
}
.custom-tree-node img {
  width: 18px;
  margin-right: 10px;
}


</style>
<style scoped>
.task-item{
  display: flex;
  align-items: center;
  margin-left: 70px;
  margin-bottom: 20px;
}
.task-item .red{
  color: #F83C4A;
}
.task-item .el-form-item{
  margin-bottom: 0;
  display: flex;
  align-items: center
}
 .task .el-dialog__body{
  padding-top: 20px;
}
 .task .el-form-item__label{
  word-break: keep-all;
}
 .task .el-upload__tip{
   line-height: 23px;
 }
 .task-file .el-form-item__label{
  align-self: flex-start;
}
</style>
<template>
  <div class="content task">
    <div class="search-area">
      <el-form>
      <el-row :gutter="24">
        <el-col  :span="6">
            <el-form-item label="发起厂商：">
            <el-select v-model="page.manufacturerGuid" placeholder="请选择发起厂商" class="ipt-sty fl">
                  <el-option 
                    v-for="item in approvalerList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid">
               </el-option>
            </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="任务名称:">
            <el-input v-model="page.campaignsName" class="ipt-sty" placeholder="请输入任务名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
           <el-form-item label="发布状态：">
            <el-select v-model="page.campaignsState" placeholder="请选择" class="ipt-sty fl">
              <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="6">

          <div style="float:right;padding-right:40px">
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty">清空</el-button>
          </div>
          </el-col>
      </el-row>
    </el-form>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')" v-loading.fullscreen.lock="fullscreenLoading">发布任务</el-button>
    </div>
    <div class="back-color-fff p16 content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="height:100%">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsName" label="任务名称" header-align="center" align="left" width="150" fixed="left"></el-table-column>
        <el-table-column prop="campaignsState" label="任务类型" header-align="center" align="left">
          <template slot-scope="scope">{{ getCampaignsTypeName(scope.row.campaignsType) }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="是否有反馈" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.isFeedback }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="通知人员" header-align="center" align="left">
          <template slot-scope="scope">
            <div @click="getNoticeDetail(scope.row.tenantGuid,scope.row.guid)" style="text-decoration: underline; color: #4fa1a4; cursor: pointer">
              {{ scope.row.noticeTotal }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="反馈人数" header-align="center" align="left">
          <template slot-scope="scope">
            <div @click="getfankuiDetail(scope.row.guid)" style="text-decoration: underline; color: #4fa1a4; cursor: pointer">
              {{ scope.row.feedbackCount }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="manufacturerName" label="发起厂商" header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="campaignsState" label="任务状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.campaignsState == 'P' ? '已发布' : '已撤回' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="200px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row.guid)">编辑 ｜</a>
            <a class="txt-color" v-if="scope.row.campaignsState == 'P'" @click="getCancel(scope.row.guid)">撤回｜</a>
            <a class="txt-color" v-else @click="add(2, scope.row.guid)">发布｜</a>
            <a class="txt-color" @click="getDelete(scope.row.guid)">删除｜</a>
            <a class="txt-color" @click="getfankuiDetail(scope.row.guid)">反馈明细</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex" :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible1" width="50%">

      <el-form :model="ruleForm" ref="ruleForm" :label-position="right" class="demo-ruleForm">
        <div class="activity-sub-title"><span></span>任务信息</div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="发起厂商：">
            <el-select v-model="tenantGuid" placeholder="请选择发起厂商" class="fl" style="width:300px">
                  <el-option 
                    v-for="item in approvalerList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid">
               </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="任务名称：">
            <el-input type="text" style="width:300px" placeholder="请输入任务名称" v-model="campaignsName"> </el-input>
          </el-form-item>
        </div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="任务类型：">
            <el-select v-model="campaignsType" @visible-change="getDict" placeholder="请选择任务类型" class="fl" style="width:300px">
              <el-option v-for="item in campaignsTypes" :key="item.campaignsType" :label="item.label" :value="item.campaignsType"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="任务名称：">
            <el-input style="width:300px;" type="textarea" placeholder="请输入内容" v-model="campaignsContent"> </el-input>
          </el-form-item>
        </div>
        <div class="activity-sub-title"><span></span>
          上传政策文件 <i>政策文件和宣传图二选一上传</i>
        </div>
        <div class="task-item task-file">
          <el-form-item label="上传政策文件：">
            <el-upload class="upload-demo fl t-left" action="#" multiple :limit="1" accept=".pdf,.PDF" :on-exceed="handleExceed" :on-remove="handlePdfRemove" :http-request="uploadPdf" :file-list="filePdfAttachList">
              <el-button size="medium" type="info">点击上传文件</el-button>
              <div slot="tip" class="el-upload__tip">
                当前仅支持 PDF 格式文件（大小在2M以内），建议使用 Office 2010 及以上版本
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div style="margin-left:70px">
          <el-form-item label="上传宣传图：">
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl1" alt="" />
            </el-dialog>
            <el-upload action="#" name="image" class="fl" :limit="2" list-type="picture-card" :headers="token" :file-list="fileList" :on-exceed="handleExceed" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove" :http-request="uploadImage">
              <div slot="image" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </div>
        <div class="task-item" style="margin-top:20px;">
          <span class="red">*</span>
          <el-form-item label="反馈要求：">
            <el-radio-group v-model="feedbackType">
              <el-radio label="1">阅读即可</el-radio>
              <el-radio label="2">要求反馈意见</el-radio>
              <el-radio label="3">要求反馈同意与否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="保密程度：">
            <el-radio-group v-model="safeType">
              <el-radio label="1">高</el-radio>
              <el-radio label="2">中</el-radio>
              <el-radio label="3">低</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="activity-sub-title" style="margin-top:20px"><span></span>发布对象</div>
        <div class="task-item">
          <span class="red">*</span>
          <el-form-item label="指定对象：">
            <div class="t-left">
              已选{{ areaDataList.length }}个成员 <a class="txt-color" @click="chooseDepartment()">选择成员</a>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '发布任务'" @click="enterpriseCampaigns" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        <el-button size="medium" type="info" v-else @click="enterpriseCampaignsUpdate" v-loading.fullscreen.lock="fullscreenLoading">修 改</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择组织" :visible.sync="visible2" width="60%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <div v-if="tabType == 1">
              成员搜索：<el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入成员搜索"></el-input>
            </div>
            <div v-if="tabType == 2">
              标签搜索：<el-input @keyup.enter.native="labelSearch" v-model="filterTextII" class="ipt-sty mt15" placeholder="请输入标签搜索"></el-input>
            </div>
            <div class="tab-plane">
              <div :class="tabType == 1 ? 'tab-list tab-active' : 'tab-list'" @click="tabChange(1)">组织架构</div>
              <div :class="tabType == 2 ? 'tab-list tab-active' : 'tab-list'" @click="tabChange(2)">标签</div>
            </div>
             <el-tree
               class="block mt15"
               v-if="tabType == 1" 
              :data="areaData"
              :show-checkbox="true"
              node-key="guid"
              :filter-node-method="filterNodeDep"
              @node-click="handleNodeClick"
              ref="treeDep"
              check-strictly
              @check-change="checkChange"
              @check="checkChange"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img v-if="data.nodeType ==1" src="../../assets/images/ico_ora.png" alt="" />
                <img v-else src="../../assets/images/icon_per.png" alt="">
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
            <div class="block mt15" v-if="tabType == 2">
              <div class="tags-list" v-for="(item, index) in tagsList" :key="index" @click="tagsSelect(index)">
                <div class="tags-list-left">
                  <img class="tags-logo" src="../../assets/images/tab_tags.png" alt="" />
                  <span> {{ item.labelName }}</span>
                </div>
                <div class="tags-list-right" v-if="item.isShow"><i class="el-icon-check"></i></div>
              </div>
              <p class="no-tag-data" v-if="tagsList.length == 0">暂无数据</p>
            </div>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ areaDataList.length }}个成员</p>
            <el-button size="medium" type="danger" @click="del" class="fr" style="margin-top: 5px">批量删除</el-button>
            <el-table :data="areaDataList" v-loading="tableLoading" border height="280px" style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="name" label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="visible2 = false">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>

    <el-dialog title="反馈明细" :visible.sync="visible3" height="400px" center>
      <div class="search-area" style="padding-top: 0">
        <el-row :gutter="22">
          <el-col :span="8">人名 <el-input v-model="pageII.staffName" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="10">
            是否同意
            <el-select v-model="pageII.feedbackAgree" placeholder="请选择" class="ipt-sty">
              <el-option v-for="item in feedbackAgreeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div style="dispaly: flex; align-items: center">
              <el-button size="small" type="info" @click="feedBackSearch">搜索</el-button>
              <el-button size="small" type="danger" @click="feedBackClear">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table :data="feedList" border style="width: 100%" min-height="300px">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (pageII.pageIndex - 1) * pageII.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="反馈人员" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="岗位名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.positionName }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="反馈意见" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.feedbackContent }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="反馈同意与否" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.feedbackAgree == 0 ? '不同意' : '同意' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChangeII" @current-change="handleCurrentChangeII" :page-sizes="[10, 100, 200]" :current-page="pageII.pageIndex"
        :page-size="pageII.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageII.totalRows">
      </el-pagination>
    </el-dialog>

    <el-dialog title="通知人员明细" :visible.sync="visible4" height="400px" center>
      <div class="search-area" style="padding-top: 0">
        <el-row :gutter="22">
          <el-col :span="8">人名 <el-input v-model="pageIII.staffName" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="10">
            已读状态
            <el-select v-model="pageIII.isRead" placeholder="请选择" class="ipt-sty">
              <el-option v-for="item in isReadList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div style="dispaly: flex; align-items: center">
              <el-button size="small" type="info" @click="noticeSearch">搜索</el-button>
              <el-button size="small" type="danger" @click="noticeClear">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table :data="noticeList" border style="width: 100%" min-height="300px">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (pageII.pageIndex - 1) * pageII.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="反馈人员" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.staffName }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="岗位名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.positionNames[0] }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="已读状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.isRead == 'Y' ? '已读' : '未读' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="已读时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChangeIII" @current-change="handleCurrentChangeIII" :page-sizes="[10, 100, 200]" :current-page="pageIII.pageIndex"
        :page-size="pageIII.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageIII.totalRows">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
    rules: {
          logonUser: [{ required: true, trigger: 'blur', message: '请输入账号',},
                    { min: 1, max: 20, message: '请输入长度在 1-20 个字符', trigger: 'blur' },
                    { validator: this.checkData, trigger: 'blur' }],
          pwd: [{ required: true, trigger: 'blur', message: '请输入密码',},
                { min: 6, max: 20, message: '请输入长度在 6-20 个字符', trigger: 'blur' },
                { validator: this.checkData, trigger: 'blur' }],
        },
      fullscreenLoading: false,
      textTitle: '发布任务',
      active: 0,
      filterText: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startTime: '',
        endTime: '',
        campaignsName: '',
        campaignsState: '',
        tenantGuid:'',
      },
      campaignsName: '',
      areaDataList: [],
      tenantGuid: '',
      visible2: false,
      dialogVisible2: false,
      dialogVisible1: false,
      textarea: '',
      fileList: [],
      filePdfList: [],
      filePdfAttachList: [],
      dialogImageUrl1: '',
      dialogVisible: false,
      disabled: false,
      activityAttach: [],
      fileList1: [],
      ruleForm: {},
      areaData: [],
      approvalerList: [],
      stateList: [
        {
          label: '已发布',
          value: 'P',
        },
        {
          label: '已撤回',
          value: 'C',
        },
      ],
      tableData: [],
      right: 'right',
      tableLoading: false,
      height: window.innerHeight - 360,
      delList: [],
      enterpriseCampaignsGuid: '',
      area: [],

      feedbackType: '', //反馈要求
      safeType: '', //保密程度
      campaignsContent: '', //任务名称
      campaignsType: '', //任务类型

      campaignsTypes: [],
      feedList: [],
      pageII: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        feedbackAgree: '',
      },
      feedbackAgreeList: [
        {
          label: '同意',
          value: '1',
        },
        {
          label: '不同意',
          value: '0',
        },
      ],
      feedBackGuid: null,
      visible3: false,

      noticeList: [],
      pageIII: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        isRead: '',
      },
      isReadList: [
        {
          label: '已读',
          value: 'Y',
        },
        {
          label: '未读',
          value: 'N',
        },
      ],
      noticeGuid: null,
      visible4: false,
      tabType: 1,

      labelGuids: [],
      defaultProps: {
        id: 'id',
        label: 'label',
        children: 'children',
      },
      filterTextII: '',
      tagsList: [],
      departList:[]
    };
  },
  created() {
    // 列表
    this.getApprovalOrganization();
  },
  watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    tenantGuid(val) {
      this.getTagsList(val);
      this.getOrganisation();
    },
    visible2(val){
      this.dialogVisible1 = !val;
    }
  },
  methods: {
    chooseDepartment(){
      this.visible2 =  true
      let arr =[]
      this.areaDataList.forEach(item=>{
        arr.push(item.guid)
      })
      this.$nextTick(()=>{
         this.$refs.treeDep.setCheckedKeys(arr)
      })
    },
    // 获取通知类型字典
    getDict(type){
      if(!type) return 
      if(this.tenantGuid){
      let that = this;
      that.api.get(`/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${that.tenantGuid}&code=RWTZGL_RWLX`,
        ).then((resp) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data?resp.data.data:[]
            let arr = []
            data.forEach(item=>{
              let obj={
                label: item.name,
                campaignsType: item.parameterValue,
              }
              arr.push(obj)
            })
            that.campaignsTypes = arr
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }else{
        this.$message.warning('请选择发起厂商！')
      }
    },
    labelSearch() {
      this.getTagsList(this.tenantGuid, this.filterTextII);
    },
    //选中标签
    tagsSelect(index) {
      var areaDataList = [];
      var tagsList = this.tagsList;
      tagsList[index].isShow = !tagsList[index].isShow;
      this.tagsList = tagsList;
      tagsList.forEach((item) => {
        item.name = item.labelName;
        if (item.isShow) {
          areaDataList.push(item);
        }
      });
      this.areaDataList = areaDataList;
      this.$forceUpdate();
    },
    tabChange(num) {
      var tagsList = this.tagsList;
      this.tabType = num;
      this.areaDataList = [];
      tagsList.forEach((item) => {
        item.isShow = false;
      });
      this.tagsList = tagsList;
      this.$forceUpdate();
    },
    //获取标签列表
    getTagsList(tenantGuid, labelName) {
      let self = this;
      let url;
      if (labelName) {
        url =
          `/${serverConfig.msPersonnelService}/label/list?pageIndex=1&pageSize=-1&tenantGuid=` +
          tenantGuid +
          '&labelName=' +
          labelName;
      } else {
        url = `/${serverConfig.msPersonnelService}/label/list?pageIndex=1&pageSize=-1&tenantGuid=` + tenantGuid;
      }
      self.api.get(url).then((res) => {
        self.tagsList = [];
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records !== null) {
            self.tagsList = res.data.data.records;
          } else {
            self.tagsList = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
        this.$forceUpdate();
      });
    },
    noticeSearch() {
      this.getNoticeList();
    },
    noticeClear() {
      this.pageIII = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        isRead: '',
      };
      this.getNoticeList();
    },
    feedBackSearch() {
      this.getFeedList();
    },
    feedBackClear() {
      this.pageII = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        feedbackAgree: '',
      };
      this.getFeedList();
    },
    getCampaignsTypeName(campaignsType) {
      var campaignsTypes = this.campaignsTypes;
      var label;
      campaignsTypes.forEach((item) => {
        if (item.campaignsType == campaignsType) {
          label = item.label;
        }
      });
      return label;
    },
    //获取组织
    getOrganisation() {
      let self = this;
      self.areaData = [];
      if (self.tenantGuid == null || self.tenantGuid == '') {
        self.$message.error('请选择发起厂商！');
      } else {
      let query = {
        tenantGuid:self.tenantGuid,
      }
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`,query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            this.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
      }
    },
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: this.tenantGuid,
        staffType: '1',
        bizState: 'Y',
        organisationGuid: organisationGuid,
      };
      return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // self.tableLoading = false;
            const records = res.data.data.records;
            (records || []).forEach((k) => {
              k.label = k.staffName;
              k.id = k.guid;
              k.icon = require('../../assets/images/icon_per.png');
            });
            resolve(records);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    treeData(areaData) {
      var self = this;
      const fn = (tree) => {
        tree.forEach(async (k) => {
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
               const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== '[]';
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              k.children = [...k.children];
              // 有子元素，需要调用自身
            } 
          }
        });
      };
      fn(areaData);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    checkChange(val) {
      var list = this.$refs.treeDep.getCheckedNodes();
      this.areaDataList = list;
    },
    //获取公司
    getApprovalOrganization() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.approvalerList = res.data.data;
          self.page.manufacturerGuid = self.approvalerList[0].sendTenantGuid;
          self.getData(false);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    del() {
      let self = this;
      let tagsList = this.tagsList;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选成员！');
        return;
      }
      if (self.delList.length == self.areaDataList.length) {
        tagsList.forEach((item) => {
          item.isShow = false;
        });
        self.tagsList = tagsList;
      }
      self.delList.forEach(function (j) {
        self.areaDataList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.areaDataList.splice(index, 1);
            self.tagsList[index].isShow = false;
            self.$forceUpdate();
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    handleNodeClick(data) {
      // let self = this;
      // let item = {
      //   guid: data.guid,
      //   organisationName: data.organisationName,
      // };
      // self.area.push(JSON.stringify(item));
      // self.area = self.unique(self.area);
      // self.areaDataList = [];
      // self.area.forEach(function (i) {
      //   self.areaDataList.push(JSON.parse(i));
      // });
    },
    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        userName: '',
        startTime: '',
        endTime: '',
        province: '',
      };
      self.page.manufacturerGuid = self.approvalerList[0].sendTenantGuid;
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.tableLoading = true;
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/get-enterprise-campaigns`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            console.log(res.data.data.records);
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传pdf
    uploadPdf(file) {
      let self = this;
      let formData = new FormData();
      formData.append('file', file.file);
      self.api.postImage(self.url, formData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.filePdfList = [];
          let item = {
            fileName: file.file.name,
            path: res.data.data.data,
          };
          self.filePdfList.push(item);
          self.filePdfAttachList = [];
          let item1 = {
            name: file.file.name,
            url: res.data.data.data,
          };
          self.filePdfAttachList.push(item1);
          self.$message({
            message: '上传成功',
            type: 'success',
          });
        } else {
          self.filePdfList = [];
          self.$message.error('上传失败!');
        }
      });
    },
    add(flg, guid) {
      this.getTagsList(this.tenantGuid);
      let self = this;
      if (flg == 1) {
        self.textTitle = '发布任务';
        self.campaignsName = '';

        self.campaignsContent = '';
        self.feedbackType = '';
        self.safeType = '';
        self.campaignsType = '';
        self.tenantGuid = '';
        self.filePdfList = [];
        self.filePdfAttachList = [];
        self.fileList = [];
        self.area = [];
        self.areaDataList = [];
        self.dialogVisible1 = true;
      } else {
        self.textTitle = '编辑任务';
        self.enterpriseCampaignsGuid = guid;
        self.getEnterpriseCampaignsDetail(guid);

        self.dialogVisible1 = true;
      }
    },
    getEnterpriseCampaignsDetail(guid) {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/get-enterprise-campaigns-detail?guid=` + guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.campaignsName = res.data.data.campaignsName;
            self.campaignsContent = res.data.data.campaignsContent;
            self.campaignsType = res.data.data.campaignsType;
            self.safeType = res.data.data.safeType;
            self.feedbackType = res.data.data.feedbackType;
            self.tenantGuid = res.data.data.manufacturerGuid;
            if(self.tenantGuid){
              this.getDict(true)
            }
            self.filePdfList = [];
            self.filePdfAttachList = [];
            self.activityAttach = [];
            self.fileList = [];
            if (res.data.data.organisationGuids.length != 0) {
              self.tabType = 1;
              self.getOrganisationByGuids(res.data.data.organisationGuids);
            }
            if (res.data.data.labelGuids.length != 0) {
              self.tabType = 2;
              self.getLabelByGuids(res.data.data.labelGuids);
            }
            if (res.data.data.staffGuids.length != 0) {
              self.tabType = 1;
              self.getStaffByGuids(res.data.data.staffGuids);
            }
            if (res.data.data.policyDoc != null) {
              let pdf = JSON.parse(res.data.data.policyDoc)[0];
              let item = {
                fileName: pdf.fileName,
                path: pdf.path,
              };
              self.filePdfList.push(item);
              self.filePdfAttachList = [];
              let item1 = {
                name: pdf.fileName,
                url: pdf.path,
              };
              self.filePdfAttachList.push(item1);
            }
            if (res.data.data.pictContent != null) {
              let img = JSON.parse(res.data.data.pictContent);
              img.forEach(function (i) {
                let item = {
                  name: i.fileName,
                  url: i.path,
                };
                self.fileList.push(item);
                let item1 = {
                  fileName: i.fileName,
                  path: i.path,
                };
                self.activityAttach.push(item1);
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getLabelByGuids(guids) {
      var areaDataList = [];
      var tagsList = [];
      let self = this;
      let url = `/${serverConfig.msPersonnelService}/label/list?pageIndex=1&pageSize=-1&tenantGuid=` + this.tenantGuid;
      self.api.get(url).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records !== null) {
            tagsList = res.data.data.records;
            console.log(tagsList);
            console.log(guids);
            tagsList.forEach((item) => {
              item.organisationName = item.labelName;
              if (guids.includes(item.guid)) {
                item.isShow = true;
                areaDataList.push(item);
              } else {
                item.isShow = false;
              }
             
            });
            self.areaDataList = areaDataList;
            self.$forceUpdate();
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisationByGuids(guids) {
      let self = this;
      // let reg = new RegExp( ',' , "g" );
      // let guid = guids.toString().replace(reg, '&');
      self.area = [];
      self.areaDataList = [];
      self.api.postCan(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-by-guids`, guids).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          res.data.data.forEach(function (i) {
            let item = {
              guid: i.guid,
              organisationName: i.organisationName,
            };
            self.area.push(JSON.stringify(item));
            self.areaDataList.push(item);
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaffByGuids(guids) {
      var self = this;
      let arr = []
      self.api.postCan(`/${serverConfig.msPersonnelService}//staff/data/get-staffs`, guids).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          res.data.data.forEach(function (i) {
            let item = {
              guid: i.guid,
              organisationName: i.staffName,
              isStaff: true,
            };
            self.area.push(JSON.stringify(item));
            self.areaDataList.push(item);
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // self.ruleForm.platformLogo = res.data.data;
            let item = {
              name: '任务图片',
              url: res.data.data,
            };
            self.fileList.push(item);
            let item1 = {
              fileName: '任务图片',
              path: res.data.data,
            };
            self.activityAttach.push(item1);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },

    getCancel(guid) {
      let self = this;
      // self.ruleForm.sendTime = self.$moment(self.ruleForm.sendTime).format('YYYY-MM-DD HH:mm:ss');
      self.api.postJson(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/cancel?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('撤回成功');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDelete(guid) {
      let self = this;
      // self.ruleForm.sendTime = self.$moment(self.ruleForm.sendTime).format('YYYY-MM-DD HH:mm:ss');
      let guids = [];
      guids.push(guid);
      self.api.postJson(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/delete`, guids).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('删除成功');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //重新发布
    getSend(guid) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/publish?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('发布成功');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //反馈明细
    getfankuiDetail(guid) {
      this.visible3 = true;
      this.pageII = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        feedbackAgree: '',
      };
      this.feedBackGuid = guid;
      this.getFeedList();
    },
    getNoticeDetail(noticeTenantGuid,noticeGuid) {
      this.visible4 = true;
      this.pageIII = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        isRead: '',
      };
      this.noticeTenantGuid = noticeTenantGuid
      this.noticeGuid = noticeGuid;
      this.getNoticeList();
    },
    enterpriseCampaigns() {
      let self = this;
      let organisationGuids = [];
      let staffGuids = [];
      let labelGuids = [];
      let areaDataList = this.areaDataList;

      if (!self.tenantGuid) {
        self.$message.error('请选择发起厂商!');
        return;
      }
      if (!self.campaignsName) {
        self.$message.error('请输入任务名称!');
        return;
      }
      if (!self.campaignsType) {
        self.$message.error('请选择任务类型!');
        return;
      }
      if (!self.campaignsContent) {
        self.$message.error('请填写任务名称!');
        return;
      }

      if (self.filePdfList.length == 0 && self.activityAttach.length == 0) {
        self.$message.error('政策文件和宣传图二者必须传一个！');
        return;
      }
      if (!self.feedbackType) {
        self.$message.error('请选择反馈类型!');
        return;
      }
      if (!self.safeType) {
        self.$message.error('请选择保密程度!');
        return;
      }
      if (self.areaDataList == null || self.areaDataList == '' || self.areaDataList.length == 0) {
        self.$message.error('请选择任务发布对象!');
        return;
      }
      //标签
      if (areaDataList[0].isShow) {
        areaDataList.forEach((item) => {
          labelGuids.push(item.guid);
        });
      } else {
        //组织 、人
        areaDataList.forEach((item) => {
          if (item.nodeType==2) {
            staffGuids.push(item.guid);
          } else {
            organisationGuids.push(item.guid);
          }
        });
      }

      self.fullscreenLoading = true;
      let promise = {
        campaignsType: self.campaignsType,
        campaignsName: self.campaignsName,
        campaignsContent: self.campaignsContent,
        feedbackType: self.feedbackType,
        safeType: self.safeType,

        tenantGuid: self.$store.getters.getTenantGuid,
        policyDoc: self.filePdfList,
        pictContent: self.activityAttach,
        organisationGuids: organisationGuids,
        labelGuids: labelGuids,
        staffGuids: staffGuids,
        manufacturerGuid: self.tenantGuid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/add`, promise).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible1 = false;
          self.$message.success('发布成功！');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    enterpriseCampaignsUpdate() {
      let self = this;
      let organisationGuids = [];
      let staffGuids = [];
      let labelGuids = [];
      let areaDataList = this.areaDataList;
      if (!self.tenantGuid) {
        self.$message.error('请选择发起厂商!');
        return;
      }
      if (!self.campaignsName) {
        self.$message.error('请输入任务名称!');
        return;
      }

      if (self.filePdfList.length == 0 && self.activityAttach.length == 0) {
        self.$message.error('政策文件和宣传图二者必须传一个！');
        return;
      }
      if (self.areaDataList == null || self.areaDataList == '') {
        self.$message.error('请选择任务发布对象!');
        return;
      }
      //标签
      if (areaDataList[0].isShow) {
        areaDataList.forEach((item) => {
          labelGuids.push(item.guid);
        });
      } else {
        //组织 、人
        areaDataList.forEach((item) => {
          if (item.nodeType==2) {
            staffGuids.push(item.guid);
          } else {
            organisationGuids.push(item.guid);
          }
        });
      }
      let promise = {
        guid: self.enterpriseCampaignsGuid,
        campaignsType: self.campaignsType,
        campaignsName: self.campaignsName,
        campaignsContent: self.campaignsContent,
        feedbackType: self.feedbackType,
        safeType: self.safeType,

        tenantGuid: self.$store.getters.getTenantGuid,
        policyDoc: self.filePdfList,
        pictContent: self.activityAttach,
        organisationGuids: organisationGuids,
        labelGuids: labelGuids,
        staffGuids: staffGuids,
        manufacturerGuid: self.tenantGuid,
      };
      self.fullscreenLoading = true;
      self.api.put(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/update`, promise).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible1 = false;
          self.$message.success('发布成功！');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handlePdfRemove(file) {
      let self = this;
      console.log(file.url);
      self.filePdfAttachList.forEach(function (i, index) {
        if (i.url == file.url) {
          self.filePdfAttachList.splice(index, 1);
        }
      });
      self.filePdfList.forEach(function (j, ind) {
        if (j.path == file.url) {
          self.filePdfList.splice(ind, 1);
        }
      });
    },
    handleRemove(file) {
      let self = this;
      console.log(file.url);
      self.activityAttach.forEach(function (i, index) {
        if (i.path == file.url) {
          self.activityAttach.splice(index, 1);
        }
      });
      self.fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileList.splice(ind, 1);
        }
      });
      console.log(self.fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 2 个文件`);
    },
    handleDownload(file) {
      console.log(file);
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSizeChangeII(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getFeedList();
    },
    handleCurrentChangeII(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getFeedList();
    },
    handleSizeChangeIII(val) {
      let self = this;
      self.pageIII.pageSize = val;
      this.getNoticeList();
    },
    handleCurrentChangeIII(val) {
      let self = this;
      self.pageIII.pageIndex = val;
      this.getNoticeList();
    },
    getFeedList() {
      let self = this;
      self.feedList = [];
      self.pageII.guid = self.feedBackGuid;
      self.api.get(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/data/get-feedback-list`, self.pageII).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.feedList = res.data.data.records;
          self.pageII.totalPage = res.data.data.totalPages;
          self.pageII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getNoticeList() {
      let self = this;
      self.noticeList = [];
      self.pageIII.campaignGuid = self.noticeGuid;
      self.pageIII.tenantGuid = self.noticeTenantGuid
      self.api.get(`/${serverConfig.msSalesPerformService}/enterprise-campaigns/staff-notices`, self.pageIII).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.noticeList = res.data.data.records;
          self.pageIII.totalPage = res.data.data.totalPages;
          self.pageIII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.activity-sub-title{
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-left: 30px;
  margin-bottom: 14px;
}
.activity-sub-title span{
  width: 6px;
  height: 14px;
  background: #4FA1A4;
  display: inline-block;
  margin-right: 10px;
}
.activity-sub-title i{
  font-style: normal;
  color:#969799;
  font-size: 12px;
  font-weight: normal;
  margin-left: 10px;
}
</style>